// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/elements/_swiper.scss
// module id = 129
// module chunks = 0